import Checkbox from './Checkbox/Checkbox';

/**
 * `RenewalMarketingConsent` renders a single checkbox bound to journey state to
 * capture consent for renewal marketing.
 *
 * The checked state is sourced from `journey.renewalMarketing` and toggled via
 * `onUpdateRenewalMarketing`.
 */

import { useJourney } from '../sitePages/Layout';

interface RenewalMarketingConsentProps {
  renewalMarketingTickboxText: string;
}

const RenewalMarketingConsent = ({
  renewalMarketingTickboxText
}: RenewalMarketingConsentProps) => {
  const { journey, onUpdateRenewalMarketing } = useJourney();

  const { renewalMarketing } = journey;

  return (
    <div>
      <Checkbox
        id='consent-to-renewal-checkbox'
        checked={renewalMarketing}
        text={renewalMarketingTickboxText}
        onChange={() => onUpdateRenewalMarketing(!renewalMarketing)}
      />
    </div>
  );
};

export default RenewalMarketingConsent;
